export default {
  activateText: 'ÐÐ±Ð½Ð¾Ð²Ð¸ÑÑ ÑÑÐ°Ð·Ñ Ð¿Ð¾ÑÐ»Ðµ Ð²ÑÐ¿ÑÑÐºÐ°',
  deactivateText: 'ÐÐ¾ÑÑÐ½Ð¸ÑÐµ Ð²Ð½Ð¸Ð·, ÑÑÐ¾Ð±Ñ Ð¾Ð±Ð½Ð¾Ð²Ð¸ÑÑ',
  finishText: 'ÐÐ°Ð²ÐµÑÑÐ¸ÑÑ Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ðµ'
};
